import { defineComponent, h, withDirectives, resolveDirective } from 'vue';
import { QInput } from 'quasar';
import BaseComponent from './baseFormMixin.jsx';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';

import TranslationContainer from './../TranslationContainer.jsx';

import { appSettings } from '@/Shared/appSettings.js';

export default defineComponent({
    name: 'sform-password',
    mixins: [BaseComponent],
    components: {
        QInput,
        TranslationContainer
    },
    data: () => ({
    }),
    props: {
    },
    created() {
    },
    mounted() {
        this.loadComplete();
    },
    computed: {
    },
    methods: {
    },
    render() {
        let slots = {};
        if (this.hasInputLabel)
            slots.label = () => <TranslationContainer context={this} value={this.labelText}></TranslationContainer>;
        if (this.element.fieldAddonLeft)
            slots.prepend = () => this.element.fieldAddonLeft;

        if (this.hintText)
            slots.hint = () => <TranslationContainer context={this} value={this.hintText} autoOpenModal></TranslationContainer>;

        let input =
            <QInput
                type="password"
                class="caption pa-0 ma-0 sform-input-white"
                outlined
                dense
                labelSlot={this.hasInputLabel}
                bottom-slots={this.showFieldBottomSlots}
                style={{ width: "100%" }}
                modelValue={this.itemvalue}
                rules={this.rules} {...this.compilerErrorFieldProps}
                hint={this.inputHint}
                hide-hint
                persistent-hint={appSettings.DebugTranslationPrefixSetting}
                onUpdate:modelValue={(value) => this.sync(value) }
                onFocus={this.onFocus}
                onBlur={this.onBlur}
            >
                {slots}
            </QInput>;

        if (this.appearance)
            utils.applyVue2ToVue3Props(input, this.appearance);
        //input.componentOptions.propsData = { ...input.componentOptions.propsData, ...this.appearance };

        // if (this.directives && this.directives.some(a => a.name == 'on-enter-default'))
        //    input.props.autofocus = true;

        if (this.directives) {
            var applyDirectives = this.directives.map(d => {
                const dirDef = d.directive || resolveDirective(d.name);

                return [dirDef, d.value, d.arg, d.modifiers];
            });
            input = withDirectives(input, applyDirectives);
        }

        return input;
    }
});